const convertToAscii=(s, ignore = [], ignoreType = 'code')=>{
    var s_aux = '';
    for (let index = 0; index < s.length; index++) {
        const element = s[index];
        
        if(ignoreType==='code'?(ignore.indexOf(element.charCodeAt(0)) === -1):(ignore.indexOf(element) === -1)){
            if(element.charCodeAt(0) > 127){
                s_aux += `&#${element.charCodeAt(0)};`;
            }else{
                s_aux += element;
            }
        } else {
            s_aux += element;
        }
        
    }
    return s_aux;
}

export default convertToAscii;